import { render, staticRenderFns } from "./ContactsShow.vue?vue&type=template&id=017abd7b&scoped=true&lang=pug&"
import script from "./ContactsShow.vue?vue&type=script&lang=js&"
export * from "./ContactsShow.vue?vue&type=script&lang=js&"
import style0 from "./ContactsShow.vue?vue&type=style&index=0&id=017abd7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017abd7b",
  null
  
)

export default component.exports